export const SET_ERROR = 'SET_ERROR'
export const UNSET_ERROR = 'UNSET_ERROR'

export const defaultErrorState = {
  error: false,
  errorMessage: null
}

export default (state = defaultErrorState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return {
        ...state,
        error: true,
        errorMessage: action.errorMessage
      }
    case UNSET_ERROR:
      return {
        ...state,
        error: false,
        errorMessage: null
      }
    default:
      return state
  }
}
